import { createGetDataReducer } from "./CommonReducer";
import { BOOKINGLIST  ,BOOKINGDETAIL } from "../../Constants/BookingConstants";

export const BookingGetReducer = createGetDataReducer( BOOKINGLIST );
export const BookingDetailReducer = createGetDataReducer( BOOKINGDETAIL );




